import { defineMessages } from 'react-intl';

export default defineMessages({
    nextDescription: {
        id: 'rewrite.common.views.ml-required-signatures.We\'ll review <strong>your documents</strong> next',
        defaultMessage: 'We\'ll review <strong>your documents</strong> next'
    },
    applySignatureToAll: {
        id: 'rewrite.common.views.ml-required-signatures.applySignatureToAll',
        defaultMessage: 'Do you want to apply this signature type to all items in the list?'
    },
});